<div class="logo" flexLayout="row" flexLayoutAlign="start center" [routerLink]="logoRedirectLink">
  <img title="logo" [src]="logo" />
</div>
